module.exports = "\n<div style=\"display: block;\">\n  <span class=\"heading_title\">{{title}}</span>\n  <canvas  baseChart \n    [datasets]=\"data\"\n    [labels]=\"labels\"\n    [options]=\"options\"\n    [legend]=\"pieChartLegend\"\n    [colors]=\"pieChartColors\" \n    [chartType]=\"pieChartType\">\n  </canvas>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2992559088/src/src/app/common/dynamic-vendor-invoice-pie-chart/dynamic-vendor-invoice-pie-chart.component.html
// module id = ../../../../../src/app/common/dynamic-vendor-invoice-pie-chart/dynamic-vendor-invoice-pie-chart.component.html
// module chunks = main